import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExpenseAccordionComponent } from './expense-accordion.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [CommonModule, TranslateModule],
  exports: [ExpenseAccordionComponent],
  declarations: [ExpenseAccordionComponent],
})
export class ExpenseAccordionModule {}
